export default {
	tooLongDescriptionError: "Pole \"{0}\" nie może być dłuższe niż 255 znaków.",
	fieldIsRequiredError: "Pole \"{0}\" jest wymagane.",
	retypePasswordError: "Ponownie wpisane hasło jest błędne.",

	permissionLevelRequiredError: "Pole \"Poziom upoważnienia\" jest wymagane.",
	addToIssue: "Dodaj do zgłoszenia",
	dataSets: "Zbiory danych",
	businessProcesses: "Procesy biznesowe",
	resource: "Zasób",
	period: "Okres",
	authorizationLevel: "Poziom upoważnienia",
	currentAuthorizations: "Aktualne upoważnienia",

	warningEmployeeChangeTitle: "Zmiana użytkownika, którego dotyczy wniosek",
	warningEmployeeChangeText: "Czy na pewno chcesz zmienić na {0}. Cały dotychczasowy zakres zostanie usunięty.",
	selectEmployee: "Wybierz osobę",
	requestFor: "Wniosek dla",
	authorizationControlHasChanges: "Kontrolka upoważnień posiada uzupełnione dane zakresu wniosku, który nie został dodany.",

	editing: "Edycja",
	copying: "Kopiowanie",
	copy: "Kopiuj",
	accept: "Akceptuj",
	reject: "Odrzuć",

	selectApplication: "Wybierz system informatyczny",
	selectService: "Wybierz usługę",
	selectDataSet: "Wybierz zbiór danych",
	selectBusinessProcess: "Wybierz proces biznesowy",

	name: "Nazwa",
	sapId: "SAP Id",
	hrId: "HR Id",
	applicationName: "Aplikacja",
	type: "Typ",
	status: "Status",
	city: "Miasto",
	company: "Firma",
	riskLevel: "Poziom ryzyka",
	department: "Dział",

	administrativeRole: "Rola administracyjna",
	sensitiveData: "Dane wrażliwe",
	reasonForProcessingSensitiveData: "Powód przetwarzania danych wrażliwych",
	acceptCheckboxLabel: "Zapoznałem się i zrozumiałem powyższy tekst",

	step: "Krok",
	of: "z",
}